import gbAntInputTextareaLimit from "./src/gb-ant-input-textarea-limit.vue";
const gbAntInputTextareaLimitCompenet = function(Vue) {
  Vue.component(gbAntInputTextareaLimit.name, gbAntInputTextareaLimit);
};
export default gbAntInputTextareaLimitCompenet;
